import { useEffect, useState } from "react";
import { Card, Col, Container, Input, Row, Button } from "reactstrap";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getData } from "../../../CommonElements/Functions/PostGetFun";
import { API } from "../../../api/API";
import CommonTableNew from "../../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";
import { useNavigate } from "react-router-dom";
import CardHeaderSpan from "../../../Utils/CommonComponents/CardHeaderSpan";
import FeatherIconCom from "../../../Utils/CommonComponents/CommonIcons/FeatherIconCom";
import Loader from "../../../Layout/Loader";

export default function EmployeesList() {
    const [employees, setEmployees] = useState<any[]>([]);
    const [filteredEmployees, setFilteredEmployees] = useState<any[]>([]);
    const [searchText, setSearchText] = useState('');
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const serverUrl = localStorage.getItem('serverUrl');
    const APP_TOKEN = localStorage.getItem('appToken');

    const headData = [
        { id: '1', head: 'Position', key: 'PositionName', sortKey: 'PositionName' },
        { id: '2', head: 'Reporting To', key: 'ReportingToPositionName', sortKey: 'ReportingToPositionName' },
        { id: '3', head: 'Employee ID', key: 'EmployeeId', sortKey: 'EmployeeId' },
        { id: '4', head: 'First Name', key: 'FirstName', sortKey: 'FirstName' },
        { id: '5', head: 'Last Name', key: 'LastName', sortKey: 'LastName' },
        { id: '6', head: 'Employee Code', key: 'EmployeeCode', sortKey: 'EmployeeCode' },
        { id: '7', head: 'Position ID', key: 'PositionId', sortKey: 'PositionId' },
        { id: '8', head: 'Reporting To ID', key: 'ReportingTo', sortKey: 'ReportingTo' },
        { id: '9', head: 'Designation', key: 'Designations.Designation', sortKey: 'Designations.Designation' },
        { id: '10', head: 'Branch Name', key: 'Branch.Branchname', sortKey: 'Branch.Branchname' },
        { id: '11', head: 'Grade Name', key: 'GradeMaster.GradeName', sortKey: 'GradeMaster.GradeName' },
        { id: '12', head: 'Org Unit', key: 'OrgUnit.UnitName', sortKey: 'OrgUnit.UnitName' },
        { id: '13', head: 'Town Name', key: 'GeoTowns.Stownname', sortKey: 'GeoTowns.Stownname' },
    ];

    useEffect(() => {
        fetchEmployees();
    }, []);

    const fetchEmployees = async () => {
        if (!serverUrl || !APP_TOKEN) {
            console.error('❌ Missing server URL or APP_TOKEN');
            return;
        }

        setLoading(true);

        try {
            const url = `${serverUrl}${API.getEmployees}`;
            const { status, data } = await getData(url, true);

            if (status === 200 && Array.isArray(data?.data)) {
                setEmployees(data.data);
                setFilteredEmployees(data.data);
            } else {
                setEmployees([]);
                setFilteredEmployees([]);
            }
        } catch (error) {
            console.error("❌ Failed to fetch employees:", error);
            setEmployees([]);
            setFilteredEmployees([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const lower = searchText.toLowerCase();
        const filtered = employees.filter((emp) =>
            Object.values(emp).some(val =>
                String(val).toLowerCase().includes(lower)
            )
        );
        setFilteredEmployees(filtered);
    }, [searchText, employees]);

    const handleExport = () => {
        if (!filteredEmployees.length) return;
        const worksheet = XLSX.utils.json_to_sheet(filteredEmployees);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Employees");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `Employees_${new Date().toISOString().split("T")[0]}.xlsx`);
    };

    return (
        <div className="page-body p-3">
            <Container fluid>

                <Col xxl={12}>
                    <Card className="p-3">
                        <CardHeaderSpan headingClassName='pb-0 px-0' back={true} heading={'Employees List'} span={'ReportListTitle'} />

                        <Row className="justify-content-between mb-3 py-2">
                            <Col md={4}>
                                <Input
                                    type="text"
                                    placeholder="Search Employees"
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                />
                            </Col>
                            <Col md="auto">
                                <button className="btn btn-sm btn-primary d-flex align-items-center" onClick={handleExport}>
                                    <FeatherIconCom iconName="Download" size={14} className="text-light" />
                                    <span className="px-2" style={{ fontSize: 14 }}>Export</span>
                                </button>
                            </Col>
                        </Row>

                        {loading ? (
                            <Loader height="250px" />
                        ) : (
                            <CommonTableNew
                                caption=""
                                headData={headData}
                                data={filteredEmployees}
                                renderRow={(row, rowIndex) => (
                                    <tr key={rowIndex}>
                                        <td>{row.PositionName}</td>
                                        <td>{row.ReportingToPositionName}</td>
                                        <td>{row.EmployeeId}</td>
                                        <td
                                            style={{ cursor: 'pointer', color: 'blue' }}
                                            title="Employee Details"
                                            onClick={() => {
                                                if (row?.EmployeeId) {
                                                    // console.log(`/newProfile/${row?.EmployeeId}`);
                                                    navigate('/newProfile', {
                                                        state: { employeeId: row.EmployeeId }
                                                    });
                                                } else {
                                                    console.warn("Missing repCode or month");
                                                }
                                            }}
                                        >{row.FirstName}</td>
                                        <td>{row.LastName}</td>
                                        <td>{row.EmployeeCode}</td>
                                        <td>{row.PositionId}</td>
                                        <td>{row.ReportingTo}</td>
                                        <td>{row["Designations.Designation"]}</td>
                                        <td>{row["Branch.Branchname"]}</td>
                                        <td>{row["GradeMaster.GradeName"]}</td>
                                        <td>{row["OrgUnit.UnitName"]}</td>
                                        <td>{row["GeoTowns.Stownname"]}</td>
                                    </tr>
                                )}
                            />
                        )}
                    </Card>
                </Col>
            </Container>
        </div>
    );
}
